import React, { useContext, useEffect, useState } from "react";
import { LuPlus } from "react-icons/lu";
import { useToast } from "./ToastContext";
import Utils from "../utils/utils";

function getCurrentDateTimeIndianTimeZone() {
  const date = new Date().getDate().toString().padStart(2, 0);
  const month = (1 + new Date().getMonth()).toString().padStart(2, 0);
  const year = new Date().getFullYear();
  const hours = new Date().getHours();
  const minute = new Date().getMinutes();
  const seconds = new Date().getSeconds();

  return {
    date: `${year}-${month}-${date}`,
    time: String(new Date()).slice(16, 21),
  };
}

const CreateLecture = ({ token }) => {
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();

  const [anyOneCanSee, setAnyOneCanSee] = useState(false);
  const [batchData, setBatchData] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [courseData, setCoursesData] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("PGP");
  let { date, time } = getCurrentDateTimeIndianTimeZone();

  const [formData, setFormData] = useState({
    title: "",
    remarks: "",
    instructor: "",
    course: selectedCourse,
    batch: [],
    date: date,
    time: time,
    endDate: date,
    endTime: time,
    category: "Coding",
    lectureMode: "Live",
    joiningLink: "",
    videoLink: "",
  });

  const fetchCourses = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/course`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });

      if (response.status === 200) {
        const res = await response.json();
        setCoursesData(res);
      } else {
        const res = await response.json();
        showToast(res.message, "warning", false, 3000);
      }
    } catch (error) {
      showToast(
        "Courses Retreieval failed :" + error.message,
        "error",
        true,
        5000
      );
    }
  };

  const fetchBatches = async (activeBatch) => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/${activeBatch}`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });
      if (response.status === 200) {
        const res = await response.json();
        setBatchData(res);
      } else {
        const res = await response.json();
        showToast(res.message, "warning", true, 3000);
      }
    } catch (error) {
      showToast(
        "Batch Retreieval failed :" + error.message,
        "error",
        true,
        5000
      );
    }
  };

  const fetchInstructors = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/instructors/`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const ret = await response.json();
        setInstructors(ret.instructors);
      } else {
        const ret = await response.json();
        showToast(ret.message, "error", true, 3000);
      }
    } catch (error) {
      console.error("Error While Creating:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBatchSelectChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      batch: prevFormData.batch.includes(value)
        ? prevFormData.batch.filter((item) => item !== value)
        : [...prevFormData.batch, value],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.batch.length && !anyOneCanSee) {
      showToast(
        "Please select at least one Batch or Choose 'All'",
        "warning",
        true,
        3000
      );
      return;
    }

    if (!formData.videoLink && !formData.joiningLink) {
      showToast(
        "Please provide Joining Link or Video Link for the lecture.",
        "warning",
        true,
        3000
      );
      return;
    }

    const lectureTime = Utils.getCreationTime(formData.date, formData.time);
    const lectureEndTime = Utils.getCreationTime(
      formData.endDate,
      formData.endTime
    );

    if (lectureTime > lectureEndTime) {
      showToast(
        "Lecture start time can't be less than the end time.",
        true,
        3000
      );
      return;
    }

    formData["lectureTime"] = Utils.getCreationTime(
      formData.date,
      formData.time
    );

    if (!formData["lectureTime"]) {
      showToast(
        "Please provide valid date and time for the lecture.",
        "warning",
        true,
        3000
      );
      return;
    }

    formData["lectureEndTime"] = lectureEndTime;
    formData["anyone"] = anyOneCanSee ? 1 : 0;

    try {
      const response = await fetch(`${SERVER_URL}/lectures/`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        showToast(result.message, "success", false, 3000);

        setFormData({
          title: "",
          batch: [],
          date: date,
          time: time,
          endDate: date,
          endTime: time,
          category: "Coding",
          lectureMode: "Live",
          remarks: "",
          course: selectedCourse,
          joiningLink: "",
          videoLink: "",
        });
        setAnyOneCanSee(false);
      } else if (!response.ok) {
        const res = await response.json();
        showToast(res.error, "error", true, 5000);
      }
    } catch (error) {
      alert(`Something went wrong !!`);
    }
  };

  const handleCourseChange = (e) => {
    const { value } = e.target;
    setSelectedCourse(value);
    fetchBatches(value);
  };

  const handleCheckedAnyone = (e) => {
    const { checked } = e.target;
    setAnyOneCanSee(checked);
  };

  const handleCancelAddLecture = () => {
    setFormData({
      title: "",
      batch: [],
      date: date,
      time: time,
      endDate: date,
      endTime: time,
      category: "Coding",
      lectureMode: "Live",
      remarks: "",
      course: selectedCourse,
      joiningLink: "",
      videoLink: "",
    });
  };
  useEffect(() => {
    fetchCourses();
    fetchBatches("PGP");
  }, []);

  useEffect(() => {
    fetchInstructors();
    if (instructors.length > 0 && !formData.instructor) {
      setFormData((prev) => ({
        ...prev,
        instructor: `${instructors[0]._id}+${instructors[0].name}`,
      }));
    }
  }, [instructors]);

  return (
    <div bkl="CreateLectureForm">
      <div className="sticky top-0">
        <label
          htmlFor="my-drawer-4"
          className="drawer-button px-3 py-1 flex justify-center items-center gap-1 btn-sm cursor-pointer tracking-[.1em] uppercase border border-pink-700 rounded-lg text-pink-700 hover:text-pink-800 hover:border-pink-800 hover:shadow-lg"
        >
          <LuPlus className="w-5 h-5 extrabold" /> CREATE LECTURE
        </label>
      </div>

      <div className="drawer drawer-end z-[50]">
        <input id="my-drawer-4" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content"></div>
        <div className="drawer-side h-full">
          <label
            htmlFor="my-drawer-4"
            aria-label="close sidebar"
            className="drawer-overlay"
          ></label>
          <div className="menu bg-[#FFFFFF] text-base-content w-[60%] md:w-[60%] sm:w-[70%] xs:[80%] min-h-full relative p-4 border-l-2 border-l-pink-700">
            <div>
              <p className="text-lg bold">Create a new lecture</p>
            </div>
            <form onSubmit={handleSubmit} className="h-full">
              <div className="flex items-center gap-2 mt-2 w-full">
                <label className="form-control w-full">
                  <span className="label ">Title :</span>
                  <input
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                    placeholder="Please enter title properly. This is visible to students."
                    className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </div>

              <div className="flex items-center gap-2 mt-2 w-full">
                <label className="form-control w-full">
                  <span className="label ">Title Details :</span>
                  <input
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleInputChange}
                    placeholder="This is only visible to instructors."
                    className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </div>
              <div className="flex items-center gap-4 mt-2 w-full">
                <label className="form-control w-[50%]">
                  <span className="label ">Instructor :</span>
                  <select
                    name="instructor"
                    value={formData.instructor || ""}
                    onChange={handleInputChange}
                    className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
                  >
                    <option
                      value={""}
                      key={"Select Instructor"}
                      disabled
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Select Instructor
                    </option>

                    {instructors.map((instructor, i) => (
                      <option
                        value={instructor._id + "+" + instructor.name}
                        key={instructor + i}
                      >
                        {instructor.name}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="flex items-center gap-4 mt-2 w-full">
                <label className="form-control w-[50%]">
                  <span className="label ">Course :</span>
                  <select
                    name="course"
                    value={selectedCourse}
                    onChange={handleCourseChange}
                    className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
                  >
                    <optgroup label="Select Course">
                      {courseData.map((course, i) => (
                        <option value={course.name} key={course + i}>
                          {course.name}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                </label>

                <label className="form-control w-[50%]">
                  <span className="label ">All :</span>
                  <input
                    type="checkbox"
                    name="anyone"
                    defaultChecked={anyOneCanSee}
                    onClick={handleCheckedAnyone}
                    className="checkbox border-pink-700  [--chkbg:theme(colors.pink.700)] [--chkfg:white]"
                  />
                </label>
              </div>

              <div className="mt-2">
                <span className="label ">Select Multiple Batches :</span>
                <div className="flex flex-wrap gap-5">
                  {batchData.map((batch) => (
                    <div key={batch.batch} className="flex items-center gap-2">
                      <label className="flex items-center p-1 bg-gray-100 rounded-md gap-1">
                        <input
                          type="checkbox"
                          value={batch.batch}
                          className="checkbox checkbox-sm border-pink-700  [--chkbg:theme(colors.pink.700)] [--chkfg:white]"
                          checked={formData.batch.includes(batch.batch)}
                          onChange={() => handleBatchSelectChange(batch.batch)}
                        />
                        {batch.batch}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-4 mt-2 w-full">
                <label className="form-control w-[50%]">
                  <span className="label ">Date :</span>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                    className="input-sm  px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>

                <label className="form-control w-[50%] ">
                  <span className="label ">Lecture Start Time :</span>
                  <input
                    type="time"
                    name="time"
                    value={formData.time}
                    onChange={handleInputChange}
                    required
                    className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </div>

              <div className="flex items-center gap-4 mt-2 w-full">
                <label className="form-control w-[50%]">
                  <span className="label ">End Date :</span>
                  <input
                    type="date"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleInputChange}
                    required
                    className="input-sm  px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>

                <label className="form-control w-[50%] ">
                  <span className="label ">Lecture Time :</span>
                  <input
                    type="time"
                    name="endTime"
                    value={formData.endTime}
                    onChange={handleInputChange}
                    required
                    className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </div>

              <div className="flex items-center gap-4 mt-2 w-full">
                <label className="form-control w-[50%]">
                  <span className="label ">Category :</span>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    className="select select-sm outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
                  >
                    <optgroup label="Select Category">
                      <option value="Coding">Coding</option>
                      <option value="DSA">DSA</option>
                      <option value="Assignment">Assignment</option>
                      <option value="Scrum">Scrum</option>
                      <option value="Other">Other</option>
                    </optgroup>
                  </select>
                </label>

                <label className="form-control w-[50%]">
                  <span className="label ">Lecture Mode :</span>
                  <select
                    name="lectureMode"
                    value={formData.lectureMode}
                    onChange={handleInputChange}
                    className="select select-sm outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
                  >
                    <optgroup label="Select Lecture Mode">
                      <option value="Live">Live</option>
                      <option value="Video">Video</option>
                      <option value="Reading">Reading</option>
                    </optgroup>
                  </select>
                </label>
              </div>
              <div className="mt-2 w-full">
                <label className="form-control w-full">
                  <span className="label ">Joining Link :</span>
                  <input
                    type="text"
                    title="Joining Link"
                    name="joiningLink"
                    value={formData.joiningLink}
                    onChange={handleInputChange}
                    placeholder="Joining Link"
                    className="input-sm  px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </div>

              <div className="mt-2 w-full">
                <label className="form-control w-full">
                  <span className=" label  ">Video Link :</span>
                  <input
                    type="text"
                    name="videoLink"
                    value={formData.videoLink}
                    onChange={handleInputChange}
                    placeholder="Video URL"
                    title="Video Link"
                    className="input-sm px-4 py-3 rounded-lg bg-gray-50  border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </div>

              <div className="gap-2 bg-white mt-4 z-10 flex justify-between sticky bottom-1">
                <div className="flex gap-2">
                  <button
                    // className="btn px-2 py-2 btn-xs rounded  tracking-[.1em] mr-2 text-blue-700 hover:bg-blue-600 border-b-2"
                    className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-600 hover:text-green-800 hover:border-green-800 hover:shadow-lg "
                    type="submit"
                  >
                    CREATE LECTURE
                  </button>
                  <button
                    htmlFor="my-drawer-4"
                    aria-label="close sidebar"
                    className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-orange-600 rounded-lg text-orange-600 hover:text-orange-800 hover:border-orange-800 hover:shadow-lg "
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      handleCancelAddLecture();
                    }}
                  >
                    RESET
                  </button>
                </div>
                <label
                  htmlFor="my-drawer-4"
                  aria-label="close sidebar"
                  className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-red-600 rounded-lg text-red-600 hover:text-red-800 hover:border-red-800 hover:shadow-lg "
                >
                  CLOSE
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateLecture;
